import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const productInfoSliceSelector = (state: RootState) => state.productInfo;

export const productInfoSelector = createSelector(productInfoSliceSelector, (state) => state.productInfo);

export const clientPortalVersionSelector = createSelector(productInfoSelector, (productInfo) => productInfo.version);
